import { isApiError, unwrap } from "@brad-tipper/app-frontend";

import { API_URL } from "~/lib/constants";
import { api, sessionStore } from "./client";

/**
 * Uploads a file (image or PDF) to the API's private store and returns its
 * `path`. The upload is a raw body, so it is not part of the generated client.
 */
export async function uploadFile(
  body: ArrayBuffer,
  contentType: string,
): Promise<string> {
  const token = await sessionStore.getAccessToken();
  const response = await fetch(`${API_URL}/v1/uploads`, {
    method: "POST",
    headers: {
      "Content-Type": contentType,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body,
  });
  const payload = (await response.json().catch(() => null)) as {
    path?: string;
    detail?: string;
  } | null;
  if (!response.ok || !payload?.path) {
    throw new Error(
      payload?.detail ?? `Unable to upload that file (${response.status}).`,
    );
  }
  return payload.path;
}

export async function deleteUploadedFile(path: string) {
  try {
    await unwrap(api.deleteUpload({ query: { path } }));
  } catch (error) {
    // Already gone is fine.
    if (!(isApiError(error) && error.status === 404)) throw error;
  }
}

/** A short-lived signed URL the file can be displayed from. */
export async function signedFileUrl(path: string): Promise<string> {
  const result = await unwrap(api.getUploadUrl({ query: { path } }));
  return result.url;
}
